export function processReceivedData({ commit }, receivedMessage) {

  if (['initialData', 'shutDown', 'automaticSaving'].includes(receivedMessage.type)) {
    commit('updateSnapShot', receivedMessage.data);
  }

  else if (receivedMessage.type == 'processEvents') {
    commit('processEvents', receivedMessage.data);
  }

  else if (receivedMessage.type == 'updateOrders') {
    commit('updateOrders', receivedMessage.data);
  }

  else if (receivedMessage.type == 'userReq_updateSystemParams') {
    commit('updateSystemParams', receivedMessage.data);
  }

  else if (receivedMessage.type == 'userReq_getUnMappedManuals') {
    commit('updateManualOrdersMap', receivedMessage.data);
  }

  else if (['userReq_hedgeOpen', 'userReq_hedgeClose', 'userReq_reconcileSpotShort'].includes(receivedMessage.type)) {
    commit('processEvents', receivedMessage.data);
  }

  else if (receivedMessage.type == 'userReq_adjustFutures') {
    commit('adjustFutures', receivedMessage.data);
  }

  else if (receivedMessage.type == 'updateMarketData') {
    commit('updateMarketData', receivedMessage.data);
  }

  else if (receivedMessage.type == 'terminalState') {
    commit('updateTerminalState', receivedMessage.data || {});
  }
}
